type FieldMapping = Record<string, string>

export const parseBulkActionErrors = (
  errors: ReadonlyArray<{ __typename?: string; message?: string }>,
  fieldMapping: FieldMapping
): Record<string, string> => {
  const pattern = new RegExp(`(${Object.keys(fieldMapping).join('|')}): `, 'g')
  const result: Record<string, string> = {}

  for (const error of errors) {
    if (error.__typename !== 'SimpleError' || !error.message) continue

    const matches = [...error.message.matchAll(pattern)]

    for (const [i, match] of matches.entries()) {
      const backendField = match[1]
      if (!backendField) continue

      const formField = fieldMapping[backendField]
      if (!formField) continue

      const start = (match.index ?? 0) + match[0].length
      const end = matches[i + 1]?.index ?? error.message.length

      result[formField] = error.message.substring(start, end).replace(/, $/, '')
    }
  }

  return result
}

export const mapStructuredErrors = (
  errors: Record<string, string>,
  fieldMapping: FieldMapping
): Record<string, string> =>
  Object.fromEntries(
    Object.entries(errors).map(([key, value]) => {
      const formField = fieldMapping[key]
      return [formField ?? key, value]
    })
  )
